// Images
export const IMAGE_HOUSE = require('../assets/images/isotel/house.png.svg');
export const IMAGE_LOGO = require('../assets/images/isotel/logo.png.svg');
export const IMAGE_LOGO_FULL = require('../assets/images/isotel/logo_full.png.svg');

// Icons
export const ICON_CANT_CONNECT = require('../assets/images/icons/cant_connect_icon.png');
export const ICON_LOCK = require('../assets/images/icons/lock_icon.png');
export const ICON_SETTING = require('../assets/images/icons/setting.png');
export const ICON_EXCLAMATION = require('../assets/images/icons/alerts/exclamation.png');
export const ICON_LOGOUT = require('../assets/images/icons/logout.png');
export const ICON_ARROW_GRAY = require('../assets/images/icons/arrow-gray.png');

export const ICON_FRIDGE = require('../assets/images/icons/alerts/fridge.png');

export const CONTROLS_IMAGES = {
    AIR_COND: require('pluton-assets/lib/icons/svg/air-conditioner').default,
    ALARM_SYSTEM: require('pluton-assets/lib/icons/svg/alarm-system').default,
    ARROW: require('pluton-assets/lib/icons/svg/arrow').default,
    BLENDER: require('pluton-assets/lib/icons/svg/blender').default,
    COFFEE_MACHINE: require('pluton-assets/lib/icons/svg/coffee-machine').default,
    COINS: require('pluton-assets/lib/icons/svg/coins').default,
    COMPUTER: require('pluton-assets/lib/icons/svg/computer').default,
    COOKER: require('pluton-assets/lib/icons/svg/cooker').default,
    COOKER_PLATE: require('pluton-assets/lib/icons/svg/cooker-plate').default,
    CENTRAL_HEATING: require('pluton-assets/lib/icons/svg/central-heating').default,
    DEFAULT: require('pluton-assets/lib/icons/svg/unknow').default,
    DISHWASHER: require('pluton-assets/lib/icons/svg/dishwasher').default,
    DRYING_MACHINE: require('pluton-assets/lib/icons/svg/drying-machine').default,
    EXCLAMATION: require('pluton-assets/lib/icons/svg/exclamation').default,
    ELECTRICAL_CAR: require('pluton-assets/lib/icons/svg/electrical-car').default,
    ELECTRIC_HEATER: require('pluton-assets/lib/icons/svg/electric-heater').default,
    FAN: require('pluton-assets/lib/icons/svg/fan').default,
    FAN_HEATER: require('pluton-assets/lib/icons/svg/fan-heater').default,
    FAX_MACHINE: require('pluton-assets/lib/icons/svg/fax-machine').default,
    FREEZER: require('pluton-assets/lib/icons/svg/freezer').default,
    FRIDGE: require('pluton-assets/lib/icons/svg/fridge').default,
    IRON: require('pluton-assets/lib/icons/svg/iron').default,
    GRILL: require('pluton-assets/lib/icons/svg/grill').default,
    HEATING_THERMOSTAT: require('pluton-assets/lib/icons/svg/heating-thermostat').default,
    HAIR_DRYER: require('pluton-assets/lib/icons/svg/hair-dryer').default,
    JACUZZI: require('pluton-assets/lib/icons/svg/jacuzzi').default,
    KETTLE: require('pluton-assets/lib/icons/svg/kettle').default,
    KITCHEN_HOOD: require('pluton-assets/lib/icons/svg/kitchen-hood').default,
    LAMP: require('pluton-assets/lib/icons/svg/lamp').default,
    LIGHT: require('pluton-assets/lib/icons/svg/light').default,
    LIGHTNING: require('pluton-assets/lib/icons/svg/lightning').default,
    MICROWAVE: require('pluton-assets/lib/icons/svg/microwave').default,
    MOBILE_CHARGER: require('pluton-assets/lib/icons/svg/mobile-charger').default,
    NOTEBOOK: require('pluton-assets/lib/icons/svg/notebook').default,
    OVEN: require('pluton-assets/lib/icons/svg/oven').default,
    PLUG: require('pluton-assets/lib/icons/svg/plug').default,
    PUMP: require('pluton-assets/lib/icons/svg/pump').default,
    POWER_SOCKET: require('pluton-assets/lib/icons/svg/power-socket').default,
    PRINTER: require('pluton-assets/lib/icons/svg/printer').default,
    RADIO: require('pluton-assets/lib/icons/svg/radio').default,
    SOUND_SYSTEM: require('pluton-assets/lib/icons/svg/sound-system').default,
    SPA: require('pluton-assets/lib/icons/svg/spa').default,
    SOLAR_HEATING: require('pluton-assets/lib/icons/svg/solar-heating').default,
    SERVER: require('pluton-assets/lib/icons/svg/server').default,
    SELF_STANDING_LAMP: require('pluton-assets/lib/icons/svg/self-standing-lamp').default,
    TV: require('pluton-assets/lib/icons/svg/tv').default,
    TOASTER: require('pluton-assets/lib/icons/svg/toaster').default,
    VENTILATION_SYSTEM: require('pluton-assets/lib/icons/svg/ventilation-system').default,
    VACUUM_CLEANER: require('pluton-assets/lib/icons/svg/vacuum-cleaner').default,
    WASH_MACHINE: require('pluton-assets/lib/icons/svg/washing-machine').default,
    WATER_HEATER: require('pluton-assets/lib/icons/svg/water-heater').default,
    WARNING: require('pluton-assets/lib/icons/svg/warning')
};

// Icons auth
export const AUTH_IMAGES = {
    ICON_PASSWORD: require('../assets/images/icons/auth/password_icon.png'),
    ICON_USER: require('../assets/images/icons/auth/user_icon.png'),
    ICON_PIN: require('../assets/images/icons/auth/chip_icon.png'),
    ICON_MAIL: require('../assets/images/icons/auth/mail_icon.png')
};

// Icons nav
export const FOOTER_IMAGES = {
    HOME: require('../assets/images/icons/nav/home.png'),
    COST: require('../assets/images/icons/nav/data.png'),
    CONTROL: require('../assets/images/icons/nav/dashboard.png'),
    ALERT: require('../assets/images/icons/nav/chat.png'),
    MORE: require('../assets/images/icons/nav/app.png')
};

export const FOOTER_IMAGES_ACTIVE = {
    HOME: require('../assets/images/icons/nav/home-active.png'),
    COST: require('../assets/images/icons/nav/data-active.png'),
    CONTROL: require('../assets/images/icons/nav/dashboard-active.png'),
    ALERT: require('../assets/images/icons/nav/chat-active.png'),
    MORE: require('../assets/images/icons/nav/app-active.png')
};

// Icons weather
export const WEATHER_STATUS_IMAGES = {
    CLEAR: require('pluton-assets/lib/icons/weather/clear').default,
    FG: require('pluton-assets/lib/icons/weather/fg').default,
    MOD_CLOUDY: require('pluton-assets/lib/icons/weather/mod-cloudy').default,
    MOST_CLEAR: require('pluton-assets/lib/icons/weather/most-clear').default,
    OVERCAST: require('pluton-assets/lib/icons/weather/overcast').default,
    PART_CLOUDY: require('pluton-assets/lib/icons/weather/part-cloudy').default,
    PREV_CLOUDY: require('pluton-assets/lib/icons/weather/prev-cloudy').default,
    RAIN: require('pluton-assets/lib/icons/weather/rain').default,
    SLIGHT_CLOUDY: require('pluton-assets/lib/icons/weather/slight-cloudy').default,
    SNOW: require('pluton-assets/lib/icons/weather/snow').default,
    THUNDERSTORM: require('pluton-assets/lib/icons/weather/thunderstorm').default
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/constants/image.constant.js